<script>
import appConfig from "@/app.config";
import Loading from "@/components/Loading";
import {deleteBankAccount, getBankAccounts, updateBankAccount, cloneBankAccount} from "@/api/bankAccount";
import Swal from "sweetalert2";
import {getShortSites} from "@/api/sites";
import {getBanks} from "@/api/bank";
import {mapState} from "vuex";

export default {
  page: {
    title: "Dashboard",
    meta: [{name: "description", content: appConfig.description}]
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      config: state => state.auth.config,
    }),
  },
  methods: {
    resetFilter() {
      this.filter = {
        type: null,
        bank: null,
        iban: null,
        site: null,
        isEnabled: null
      }
      this.get(1);
    },
    get(page) {
      const params = {
        ...this.filter,
        page
      };
      this.loading = true;
      getBankAccounts(params).then((response) => {
        this.items = response.data.data.docs;
        this.pages = response.data.data.pages;
        this.total = response.data.data.total;
        this.limit = response.data.data.limit;
        this.loading = false;
      });
    },
    handleDelete(id) {
      Swal.fire({
        title: "Silmek istediğinizden emin misiniz?",
        text: "Bu işlemi geri alamazsınız!",
        icon: "error",
        showCancelButton: true,
        cancelButtonText: "Vazgeç",
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Sil"
      }).then((result) => {
        if (result.value) {
          deleteBankAccount(id).then(() => {
            this.get(this.page);
          })
        }
      })
    },
    handleClone(id) {
      Swal.fire({
        title: "Kopyalamak istediğinizden emin misiniz?",
        text: "Hesabı kopyaladığınızda, bu hesap limiti 0 olarak ayarlanacaktır.!",
        icon: "error",
        showCancelButton: true,
        cancelButtonText: "Vazgeç",
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Kopyala"
      }).then((result) => {
        if (result.value) {
          cloneBankAccount(id).then(() => {
            this.get(this.page);
          })
        }
      })
    },
    handleEnable(id, enable) {
      if (enable) {
        Swal.fire({
          title: "Aktif etmek istediğinizden emin misiniz?",
          icon: "success",
          showCancelButton: true,
          cancelButtonText: "Vazgeç",
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Aktif et"
        }).then((result) => {
          if (result.value) {
            updateBankAccount(id, {isEnabled: enable}).then(() => {
              this.get(this.page);
            })
          }
        })
      } else {
        Swal.fire({
          title: "Pasif etmek istediğinizden emin misiniz?",
          icon: "error",
          showCancelButton: true,
          cancelButtonText: "Vazgeç",
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Pasif et"
        }).then((result) => {
          if (result.value) {
            updateBankAccount(id, {isEnabled: enable}).then(() => {
              this.get(this.page);
            })
          }
        })
      }
    }
  },
  components: {
    Loading,
  },
  data() {
    return {
      filterOpened: false,
      filter: {
        disableStatistics: true,
        type: null,
        bank: null,
        iban: null,
        site: null,
        isEnabled: null
      },
      loading: false,
      sites: [],
      banks: [],
      items: [],
      page: 1,
      limit: 0,
      pages: 0,
      total: 0,
      typeColors: {
        "vip": "bg-success",
        "standard": "bg-warning"
      }
    };
  },
  mounted() {
    getShortSites({page: 1, limit: 1000}).then((r) => {
      this.sites = r.data.data.docs;
      getBanks({page: 1, limit: 1000}).then((r) => {
        this.banks = r.data.data.docs;
        this.get(1);
      });
    });
  },
  beforeDestroy() {
  }
};
</script>

<template>
  <div class="position-relative">
    <div class="row">
      <div class="col-12 mb-3 ">
        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <div class="d-flex align-items-center justify-content-end mb-2">
                <b-button v-b-toggle.accordion-1 variant="dark" size="sm">Tabloyu Filtrele</b-button>
              </div>
            </b-card-header>
            <b-collapse id="accordion-1" :visible="filterOpened" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text class="filter mb-2">
                  <div class="row">
                    <div v-if="user.role !=='site' && user.role !=='site_finance' " class="col-3">
                      <div class="form-group mb-2">
                        <label class="col-form-label">Site</label>
                        <select class="form-control custom-select" v-model="filter.site">
                          <option v-for="site in sites" :key="site._id" :value="site._id">{{site.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="form-group mb-2">
                        <label class="col-form-label">Banka</label>
                        <select class="form-control custom-select" v-model="filter.bank">
                          <option v-for="bank in banks" :key="bank._id" :value="bank._id">{{bank.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="form-group mb-2">
                        <label class="col-form-label">Tipi</label>
                        <select class="form-control custom-select" v-model="filter.type">
                          <option value="standard">Standart</option>
                          <option value="vip">VIP</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="form-group mb-2">
                        <label class="col-form-label">Durum</label>
                        <select class="form-control custom-select" v-model="filter.isEnabled">
                          <option value="true">Aktif</option>
                          <option value="false">Pasif</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="form-group mb-2">
                        <label class="col-form-label">IBAN</label>
                        <input type="text" class="form-control" v-model="filter.iban">
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="form-group mb-2" style="margin-top:37px;">
                        <button @click="get(1)" class="btn btn-primary mr-2">Filtrele</button>
                        <button @click="resetFilter()" class="btn btn-warning">Sıfırla</button>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-4">
              <h4 class="card-title mb-0">Banka Hesapları</h4>
              <b-button :to="'/bank-accounts/add'" variant="success" size="sm">Banka Hesabı Ekle</b-button>
            </div>
            <b-card-text class="table-responsive">
              <table class="table table-centered table-nowrap table-hover table-striped">
                <thead>
                <tr>
                  <th class="text-left">Hesap Adı</th>
                  <th class="text-left">Banka</th>
                  <th class="text-left">IBAN</th>
                  <th class="text-left">Limitler</th>
                  <th class="text-left">Kullanım</th>
                  <th class="text-center">Hesap Tipi</th>
                  <th class="text-center">Durum</th>
                  <th class="text-center">Gösterim tipi</th>
                  <th class="text-right" style="width:10%;"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item._id">
                  <td><h5 class="font-size-14 mb-0">{{ item.name }}</h5></td>
                  <td class="text-left">{{ item.bank.name || "-" }}</td>
                  <td class="text-left">{{ item.iban }}</td>
                  <td>
                    <p class="font-size-13 mb-0"><b>Günlük işlem limiti:</b> {{ item.transactionLimit }}</p>
                    <p class="font-size-13 mb-0"><b>Maksimum işlem tutarı:</b> {{ item.maxTransaction }}</p>
                    <p class="font-size-13 mb-0"><b>Minimum işlem tutarı:</b> {{ item.minTransaction }}</p>
                  </td>
                  <td>
                    <p class="font-size-13 mb-0"><b>Yatırım sayısı (bugün):</b> {{ item.depositsCount }}</p>
                    <p class="font-size-13 mb-0"><b>Yatırım tutarı (bugün):</b> {{ item.deposits | money }}</p>
                    <p class="font-size-13 mb-0"><b>Farklı Hesaptan Yatırım (toplam):</b> {{ item.depositUsage }}</p>
                  </td>
                  <td class="text-center">
                    <span class="badge badge-pill" :class="typeColors[item.type]">{{ item.type | firstChar }}</span>
                    <template v-if="item.autoVipFeature">
                      <br>
                      <small><b>Otomatik VIP</b> ({{ item.autoVipCount }}/{{ item.customers.length }})</small>
                    </template>
                  </td>
                  <td class="text-center">
                    <span v-if="item.isEnabled" @click="handleEnable(item._id, false)"
                          class="badge badge-pill bg-success cursor-pointer">Aktif</span>
                    <span v-else @click="handleEnable(item._id, true)"
                          class="badge badge-pill bg-danger cursor-pointer">Pasif</span>
                  </td>
                  <td class="text-center">
                    <span v-if="item.enabledFor === 'sites'" class="badge badge-pill bg-info">Özel</span>
                    <span v-if="item.enabledFor === 'all'" class="badge badge-pill bg-info">Herkese açık</span>
                    <span v-if="item.enabledFor === 'never'" class="badge badge-pill bg-info">Kapalı</span>
                  </td>
                  <td class="text-right">
                    <b-button :to="'/bank-accounts/' + item._id" class="mr-2" variant="warning" size="sm">Düzenle
                    </b-button>
                    <b-button @click="handleClone(item._id)" variant="success" size="sm" class="mr-2">Kopyala</b-button>
                    <b-button @click="handleDelete(item._id)" variant="danger" size="sm">Sil</b-button>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-card-text>
            <b-pagination
                v-model="page"
                :total-rows="total"
                :per-page="limit"
                @change="get"
                aria-controls="my-table"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading"/>
  </div>
</template>
